import React from 'react'

const Education = ({ active }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke={active ? "#fff" : 'var(--sidebarColor)'} strokeWidth={1.5} stroke-linecap="round" stroke-linejoin="round" className="size-6">
            <path d="M12 7v14"></path>
            <path d="M16 12h2"></path>
            <path d="M16 8h2"></path>
            <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
            <path d="M6 12h2"></path>
            <path d="M6 8h2"></path>
        </svg>
    )
}

export default Education
